module.exports = __webpack_public_path__ + "img/cooling-loads.22da265d.png";